import { render, staticRenderFns } from "./hunanTouzi.vue?vue&type=template&id=ca60b87a&scoped=true&"
import script from "./hunanTouzi.vue?vue&type=script&lang=js&"
export * from "./hunanTouzi.vue?vue&type=script&lang=js&"
import style0 from "./hunanTouzi.vue?vue&type=style&index=0&id=ca60b87a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca60b87a",
  null
  
)

export default component.exports